module.exports = __webpack_public_path__ + "img/coins2-grey.df539da4.svg";